import React, {Component} from 'react'
import "./styles/index.scss"
import makeImageLabels from "../helpers/makeImageLabels"
import printImage from "../helpers/printImage"
import {getBarcodeByArrayNumber} from './../../services/api/apiBarcode'
import compareSize from "../helpers/compareSize"
import { listLineship } from '../helpers/filtersTable'

class ExportQRItems extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: '',
            loading: false,
            listStr: '',
            listArr: [],
            number_success: 0,
            number_error: 0,
            number_not_found: 0
        }
    }


    _handleChange = e => {
        const {value} = e.target

        this.setState({
            number_success: 0,
            number_error: 0,
            number_not_found: 0,
            listStr: value,
            error: ''
        }, () => {
            const arr = this.state.listStr.split(/#|\r|\n|\t|\r\n|\s|,\s|,/)
            const newArr = arr.filter(item => item !== '')

            this.setState({
                listArr: newArr
            })
        })
    }

    _onSubmit = async (e) => {
        e.preventDefault()
        const {listArr} = this.state

        this.setState({
            error: '',
            loading: true,
        })
        if (listArr.length === 0) {
            return this.setState({
                error: 'Chưa nhập danh sách',
                loading: false,
            })
        }
        const params = {
            array_barcodes: listArr
        }
        try {
            const {data} = await getBarcodeByArrayNumber(params)

            if (!data.success) {
                return this.setState({
                    number_success: 0,
                    number_error: 0,
                    number_not_found: 0,
                    error: data.message,
                    loading: false
                })
            }

            const {
                products_success,
                products_barcode_not_found,
                total_barcodes_number_ready_print,
                total_barcodes_error
            } = data.data

            this.setState({
                number_success: total_barcodes_number_ready_print,
                number_error: total_barcodes_error,
                number_not_found: products_barcode_not_found.length
            })

            if (total_barcodes_number_ready_print > 0) {
                setTimeout(async () => {
                    const labels = this._parseLabels(products_success)
                    const image = await makeImageLabels(labels, false, 460, 170, 'admin')

                    printImage(image)
                }, 1000)
            }

            this.setState({
                loading: false,
            })
        } catch (err) {
            this.setState({
                number_success: 0,
                number_error: 0,
                number_not_found: 0,
                error: '',
                loading: false,
            })
        }
    }

    _LineShipName = (lineShip) => {
        if (!!lineShip) {
            const mappingLineShips = [
                ...listLineship,
                { value: 'usps_mn_ib_blue', name: 'USPS-IB' },
                { value: 'ib_blue_usps_mn', name: 'IB-USPS' },
            ]
            const lineShipName = mappingLineShips.filter(item => item.value === lineShip)

            return lineShipName[0]
        }
    }

    _parseLabels = (items) => {
        const results = []
        const usex = ['PR', 'AE', 'AP', 'AO', 'VI', 'AA']

        for (let item of items) {
            const { barcodeNumber, country, state, production_status, tags, labelDetails, order_type } = { ...item }
            const { shipping_carrier, meta } = { ...labelDetails }
            let { products } = { ...item }

            const lineShipName = shipping_carrier ? (!!this._LineShipName(shipping_carrier) && !!this._LineShipName(shipping_carrier).name ? this._LineShipName(shipping_carrier).name : '') : ''

            let line_ship_label = lineShipName === "ZONE9_US" ? "HW_Z9" : lineShipName === "ZONE9_CA" ? "Z9_CA" : lineShipName
            let hwUSPSArea = ''

            if (item.hasOwnProperty('filteredProducts')) {
                products = item.filteredProducts
            }

            if (['hw_usps'].includes(shipping_carrier)) {
                hwUSPSArea = meta && meta.area || 'NY'
            }

            if (['hw_tiktok', 'hw_ttship', 'hw_gb', 'hw_gb_ttship'].includes(shipping_carrier)) {
                hwUSPSArea = meta && meta.area || ''
            }

            if (!['on-hold', 'on_hold', 'cancelled'].includes(production_status)) {
                for (let i in products) {
                    const product = products[i]
                    const { color, size, designFront, designBack, designSleeveLeft, designSleeveRight, brand_name = '' } = product || {}
                    const pos = product.hasOwnProperty('pos') ? product.pos : (parseInt(i) + 1)
                    const side = `${designFront ? 'F' : ''}${designBack ? 'B' : ''}${(designSleeveLeft || designSleeveRight) ? '-' : ''}${designSleeveLeft ? 'L' : ''}${designSleeveRight ? 'R' : ''}`
                    const type = product.type
                    const isFastProduction = Array.isArray(tags) && tags.includes('fastproduction')
                    const isCutoff = Array.isArray(tags) && tags.includes('cutoff')
                    const isHQ = Array.isArray(tags) && (tags.includes('HQ') || tags.includes('HQ gap'))

                    let loc = ''

                    if ((country.toUpperCase() === 'US' && usex.indexOf(state.toUpperCase()) !== -1)) {
                        loc = "WW"
                    } else {
                        loc = country.toUpperCase()
                    }
                    if (['HW_YUN'].includes(line_ship_label) && ['AT', 'CZ', 'DE', 'HU', 'IT', 'LU', 'NL', 'PL'].includes(loc) && !tags.includes('force-yun')) {
                        line_ship_label = 'HW_EU'
                    }
                    const label = {
                        orderId: `${barcodeNumber}_${pos}`,
                        total: item.total_items,
                        pos: pos,
                        posColor: item.total_items > 1 ? 'white' : 'black',
                        posBackground: item.total_items > 1 ? 'black' : 'white',
                        color: color,
                        size: size,
                        side: side,
                        sideBackground: side === 'F' ? 'white' : 'black',
                        type: type,
                        loc: loc,
                        isFastProduction,
                        isCutoff,
                        isHQ,
                        line_ship_label,
                        hwUSPSArea,
                        order_type,
                        tags: tags,
                        brand_name: Array.isArray(brand_name) ? brand_name.join(', ') : (brand_name || ''),
                    }
                    results.push(label)
                }
            }
        }

        const sortedLabels = [...results].sort((a, b) => {
            if (a.color > b.color) return 1
            if (a.color < b.color) return -1

            const cpSize = compareSize(a.size, b.size)
            if (cpSize) return cpSize

            if (a.side > b.side) return 1
            if (a.side < b.side) return -1
            if (a.orderId > b.orderId) return 1
            if (a.orderId < b.orderId) return -1
            return 0
        })

        return sortedLabels
    }

    render() {
        const {error, loading, number_success, number_error, number_not_found} = this.state

        return (
            <div className='ExportQRcode'>
                <div className="card">
                    <div className="card-header bg-success text-white header-elements-inline">
                        <h1 className="card-title">Xuất QR code theo danh sách</h1>
                    </div>
                    <div className="card-body">
                        <div className="ExportQRContent">
                            <textarea onChange={this._handleChange} className="InputListQrCode form-control" rows={5}
                                      name="listQrcode" placeholder="Nhập danh sách mã QR"/>
                            <div className="resuls d-flex">
                                {number_success > 0 && (
                                    <div className="mt-2 mr-2 text-success">
                                        <i className="fa fa-check"/> {number_success} mã sẵn sàng in
                                    </div>
                                )}
                                {number_error > 0 && (
                                    <div className="mt-2 mr-2 text-danger">
                                        <i className="fa fa-times"/> {number_error} mã lỗi (Đơn on-hold hoặc đã hủy)
                                    </div>
                                )}
                                {number_not_found > 0 && (
                                    <div className="mt-2 mr-2 text-danger">
                                        <i className="fa fa-times-circle"/> {number_not_found} mã không tồn tại
                                    </div>
                                )}
                            </div>
                            {error && (
                                <div className="text-danger mt-2">{error}</div>
                            )}
                            <div className="ButtonExportQR mt-2">
                                <button onClick={this._onSubmit} disabled={loading} type="button"
                                        className="btn btn-primary">{loading ? 'Đang in ...' : 'In QR code'}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ExportQRItems
